export default __webpack_public_path__ + "static/media/shape-heart.52fa8d0b.PNG";